import { FleetManagementPermissions } from "../types/FleetManagement.types";

/** Permissions may come as object arrays (companies/users/costCenterUnits) or id arrays (companyIds/userIds/costCenterUnitIds). */
type PermissionsLike = FleetManagementPermissions | Record<string, unknown>;

/** Missing or non-array values are treated as empty (no permissions assigned). */
function getPermissionIds(
  p: PermissionsLike,
  objectKey: "companies" | "costCenterUnits" | "users",
  idsKey: "companyIds" | "costCenterUnitIds" | "userIds"
): string[] {
  const objects = (p as Record<string, unknown>)[objectKey];
  const ids = (p as Record<string, unknown>)[idsKey];
  if (Array.isArray(ids)) return ids;
  if (Array.isArray(objects))
    return objects.map((o: { id?: string }) => o.id ?? "").filter(Boolean);
  return [];
}

export function permissionsEqual(a: PermissionsLike, b: PermissionsLike): boolean {
  const aCompanyIds = getPermissionIds(a, "companies", "companyIds");
  const bCompanyIds = getPermissionIds(b, "companies", "companyIds");
  const aCostCenterUnitIds = getPermissionIds(a, "costCenterUnits", "costCenterUnitIds");
  const bCostCenterUnitIds = getPermissionIds(b, "costCenterUnits", "costCenterUnitIds");
  const aUserIds = getPermissionIds(a, "users", "userIds");
  const bUserIds = getPermissionIds(b, "users", "userIds");

  return (
    aCompanyIds.length === bCompanyIds.length &&
    aCompanyIds.every((id, i) => id === bCompanyIds[i]) &&
    aCostCenterUnitIds.length === bCostCenterUnitIds.length &&
    aCostCenterUnitIds.every((id, i) => id === bCostCenterUnitIds[i]) &&
    aUserIds.length === bUserIds.length &&
    aUserIds.every((id, i) => id === bUserIds[i])
  );
}
